import React__default, { useState, useEffect } from 'react';
import cn from 'classnames';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Button } from '../Button/index.js';
import { useModal } from '../Modal/index.js';
import styles from 'ui-components/Dialogue.scss';

var _excluded = ["open", "setOpen", "className", "title", "closeIcon", "primaryAction", "secondaryAction", "onPrimaryAction", "onSecondaryAction", "onOpen", "onClose", "children"];
var defaultCloseIcon = /*#__PURE__*/React__default.createElement("svg", {
  height: "9.89941",
  viewBox: "0 0 9.89941 9.89941",
  width: "9.89941",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "m9.899 1.414-1.414-1.414-3.535 3.536-3.536-3.536-1.414 1.414 3.536 3.536-3.536 3.535 1.414 1.414 3.536-3.535 3.535 3.535 1.414-1.414-3.535-3.535z",
  fill: "currentColor"
}));
var Dialogue = function Dialogue(_ref) {
  var _cn, _cn2, _cn3;
  var open = _ref.open,
    setOpen = _ref.setOpen,
    className = _ref.className,
    title = _ref.title,
    _ref$closeIcon = _ref.closeIcon,
    closeIcon = _ref$closeIcon === void 0 ? defaultCloseIcon : _ref$closeIcon,
    primaryAction = _ref.primaryAction,
    secondaryAction = _ref.secondaryAction,
    onPrimaryAction = _ref.onPrimaryAction,
    onSecondaryAction = _ref.onSecondaryAction,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useState = useState(false),
    isEntering = _useState[0],
    setEnter = _useState[1];
  var _useState2 = useState(false),
    isLeaving = _useState2[0],
    setLeave = _useState2[1];
  var _useState3 = useState(false),
    openLocal = _useState3[0],
    setOpenLocal = _useState3[1];
  var setOpenIfReady = function setOpenIfReady(x) {
    if (!isEntering && !isLeaving) {
      setOpen(x);
    }
  };
  var setIsOpen = function setIsOpen(v) {
    if (!isEntering && !isLeaving) {
      if (v) {
        setOpenLocal(true);
        setEnter(true);
        setTimeout(function () {
          setEnter(false);
          if (typeof onOpen === "function") {
            onOpen();
          }
        }, 500);
      } else {
        setLeave(true);
        setTimeout(function () {
          setLeave(false);
          setOpenLocal(false);
          if (typeof onClose === "function") {
            onClose();
          }
        }, 500);
      }
    }
  };
  useEffect(function () {
    setIsOpen(open);
  }, [open]);
  var _useModal = useModal(openLocal, setOpenIfReady),
    Modal = _useModal.Modal;
  return /*#__PURE__*/React__default.createElement(Modal, {
    className: cn(styles.wrapper, (_cn = {}, _cn[styles.enter] = isEntering, _cn), (_cn2 = {}, _cn2[styles.leave] = isLeaving, _cn2))
  }, /*#__PURE__*/React__default.createElement("div", _extends({}, props, {
    className: cn(styles.block, className, (_cn3 = {}, _cn3[styles[props.position]] = Boolean(props.position), _cn3))
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles.bg
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles.main
  }, Boolean(title) && /*#__PURE__*/React__default.createElement("div", {
    className: styles.topSection
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.title
  }, title), /*#__PURE__*/React__default.createElement("div", {
    className: styles.closeIcon,
    onClick: function onClick() {
      return setOpenIfReady(false);
    }
  }, closeIcon)), /*#__PURE__*/React__default.createElement("div", {
    className: styles.body
  }, children)), (Boolean(primaryAction) || Boolean(secondaryAction)) && /*#__PURE__*/React__default.createElement("div", {
    className: styles.actions
  }, secondaryAction != null && /*#__PURE__*/React__default.createElement(Button, {
    className: styles.secondary,
    size: "small",
    variant: "blank",
    onClick: function onClick() {
      return onSecondaryAction && onSecondaryAction();
    }
  }, secondaryAction), primaryAction != null && /*#__PURE__*/React__default.createElement(Button, {
    size: "small",
    variant: "blank",
    onClick: function onClick() {
      return onPrimaryAction && onPrimaryAction();
    }
  }, primaryAction))), /*#__PURE__*/React__default.createElement("div", {
    className: styles.overlay,
    onClick: function onClick() {
      setOpenIfReady(false);
    }
  }));
};

export { Dialogue };
//# sourceMappingURL=index.js.map
